import http from "./http";

function getVehicleCategory(data) {
  return http.post(`vehicle_List`, data);
}
function addVehicleCategory(data) {
  return http.post(`add_Vehicle`, data);
}
function updateVehicleCategory(data) {
  return http.post(`update_Vehicle`, data);
}
function deleteVehicleCategory(data) {
  return http.post(`delete_Vehicle`, data);
}

const VehicleCategoryService = {
  getVehicleCategory,
  addVehicleCategory,
  updateVehicleCategory,
  deleteVehicleCategory,
};

export default VehicleCategoryService;
